import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FolderDto, GalleryPresetDto } from '@picflow/types';
import { StandardGalleryPreset } from '../../../configs/standard-presets';
import { CreateGalleryDialogComponent } from '../../../gallery/dialogs/create-gallery-dialog/create-gallery-dialog.component';
import { GROWTHBOOK } from '../../../growthbook';
import { DialogService } from '../../../services/dialog.service';
import { GalleryPresetService } from '../../../services/gallery-preset.service';
import { ProTagComponent } from '../../../shared-extra/components/pro-tag/pro-tag.component';
import { PermissionsPipe } from '../../../shared-extra/pipes/permissions.pipe';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { CreateFolderDialogComponent } from '../../dialogs/create-folder-dialog/create-folder-dialog.component';

@Component({
  selector: 'app-create-gallery-context',
  templateUrl: './create-gallery-context.component.html',
  styleUrls: ['./create-gallery-context.component.scss'],
  standalone: true,
  imports: [
    ButtonMenuItemComponent,
    RouterLink,
    LoadingIndicatorComponent,
    TooltipDirective,
    ProTagComponent,
    PermissionsPipe,
  ],
})
export class CreateGalleryContextComponent implements OnInit {
  @Input() folder: FolderDto;
  @Input() reOpenFn: (...args) => void;
  @Input() showDialogForGalleryCreation: boolean;
  @Output() onClose = new EventEmitter();
  customPresets: GalleryPresetDto[];
  standardPresets: StandardGalleryPreset[];
  loading = true;
  public growthBook = inject(GROWTHBOOK);

  constructor(
    private galleryPresetService: GalleryPresetService,
    private dialog: DialogService,
    private router: Router
  ) {}

  async ngOnInit() {
    this.standardPresets = await this.galleryPresetService.getStandardGalleryPresets();
    this.customPresets = await this.galleryPresetService.getCustomGalleryPresets();

    this.loading = false;
  }

  async createFolder() {
    const folder = <FolderDto>await this.dialog.open(CreateFolderDialogComponent, { parent: this.folder });
    if (folder && !this.reOpenFn) {
      this.router.navigate(['/a', 'galleries', folder.id]);
    }
    if (this.reOpenFn) this.reOpenFn(undefined, folder);
  }

  async onCreateGallery(path: string[], query: { [key: string]: string }) {
    if (!this.showDialogForGalleryCreation) {
      return this.router.navigate(path, { queryParams: query });
    }
    const preset = path[path.length - 1] === 'create' ? undefined : path[path.length - 1];
    const gallery = await this.dialog.open(CreateGalleryDialogComponent, { folder: this.folder, preset });
    if (this.reOpenFn) this.reOpenFn(gallery);
  }
}
